<template>
    <div style="width:100%; margin-left: 10px;">
		<el-row :gutter="10">
			<el-col :span="8">
				<el-autocomplete prefix-icon="el-icon-search" v-model="search_word" placeholder="輸入戶名、水號或表號查詢" size="small"
				@select="handleSelect" :fetch-suggestions="querySearch" />
			</el-col>
		</el-row>
		<el-divider > 				
			<el-switch v-model="type" active-text="流量計" active-value="流量計" active-color="#49c5ff" inactive-text="壓力計" inactive-value="壓力計" inactive-color="#49c5ff" @change="updateMap()" />
		</el-divider>
		<div v-loading="loading" element-loading-text="地圖載入中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" >
			<div style="width: 100%; height: 700px; border: 1px solid #C0C0C0"  ref="map-root" />
			<!-- <div ref="popup" class="box" >
				<div v-for="(item, key) in content" :key="key">
					<div v-if="item.label == target">
						<span @click.self="routerPush(item.waterId, item.waterNum, item.meterNum)" style="background-color: goldenrod;">{{ item.label }}</span> <br>
					</div>
					<div v-else>
						<span @click.self="routerPush(item.waterId, item.waterNum, item.meterNum)">{{ item.label }}</span> <br>
					</div>
				</div>
			</div> -->
			<!-- <div ref="statistic_1">
				<el-card class="card">
					<div slot="header">
						<span>東區分處</span>
						<el-button style="float: right; padding: 3px 0" type="text" @click="closeCard('1')">關閉</el-button>
						<el-table :data="tableData['1']" style="width: 100%" size="mini">
							<el-table-column prop="index" label="" />
							<el-table-column prop="leakage" label="洩漏" width="60" />
							<el-table-column prop="lost" label="斷訊" width="60" />
							<el-table-column prop="normal" label="正常" width="60" />
						</el-table>
					</div>
				</el-card>
			</div>
			<div ref="statistic_2">
				<el-card class="card">
					<div slot="header">
						<span>西區分處</span>
						<el-button style="float: right; padding: 3px 0" type="text" @click="closeCard('2')">關閉</el-button>
						<el-table :data="tableData['2']" style="width: 100%" size="mini">
							<el-table-column prop="index" label="" />
							<el-table-column prop="leakage" label="洩漏" width="60" />
							<el-table-column prop="lost" label="斷訊" width="60" />
							<el-table-column prop="normal" label="正常" width="60" />
						</el-table>
					</div>
				</el-card>
			</div>
			<div ref="statistic_3">
				<el-card class="card">
					<div slot="header">
						<span>南區分處</span>
						<el-button style="float: right; padding: 3px 0" type="text" @click="closeCard('3')">關閉</el-button>
						<el-table :data="tableData['3']" style="width: 100%" size="mini">
							<el-table-column prop="index" label="" />
							<el-table-column prop="leakage" label="洩漏" width="60" />
							<el-table-column prop="lost" label="斷訊" width="60" />
							<el-table-column prop="normal" label="正常" width="60" />
						</el-table>
					</div>
				</el-card>
			</div>
			<div ref="statistic_4">
				<el-card class="card">
					<div slot="header">
						<span>北區分處</span>
						<el-button style="float: right; padding: 3px 0" type="text" @click="closeCard('4')">關閉</el-button>
						<el-table :data="tableData['4']" style="width: 100%" size="mini">
							<el-table-column prop="index" label="" />
							<el-table-column prop="leakage" label="洩漏" width="60" />
							<el-table-column prop="lost" label="斷訊" width="60" />
							<el-table-column prop="normal" label="正常" width="60" />
						</el-table>
					</div>
				</el-card>
			</div>
			<div ref="statistic_5">
				<el-card class="card">
					<div slot="header">
						<span>陽明分處</span>
						<el-button style="float: right; padding: 3px 0" type="text" @click="closeCard('5')">關閉</el-button>
						<el-table :data="tableData['5']" style="width: 100%" size="mini">
							<el-table-column prop="index" label="" />
							<el-table-column prop="leakage" label="洩漏" width="60" />
							<el-table-column prop="lost" label="斷訊" width="60" />
							<el-table-column prop="normal" label="正常" width="60" />
						</el-table>
					</div>
				</el-card>
			</div> -->
		</div>	
	</div>
</template>

<script>
import { Vector as VectorSource} from 'ol/source'
import { boundingExtent } from 'ol/extent.js'
import 'ol/ol.css'
import _ from 'lodash'

import { Loader } from '@googlemaps/js-api-loader'
import { MarkerClusterer } from "@googlemaps/markerclusterer"

export default {
	// tgosMap
	name: 'tgosMap',
	data() {
		return {
			map_loader: "",
			markerCluster: "",
			infoWindow: "",
			target: "",
			search_word: "",
			points: [],
			labels: [],
			points_g: [],
			labels_g: [],
			type: "流量計",
			loading: false,
			map: null,
			clusters: null,
			layer: null,
			statistic_1_overlay: null,
			statistic_2_overlay: null,
			statistic_3_overlay: null,
			statistic_4_overlay: null,
			statistic_5_overlay: null,
			tableData: {
				"1": [],
				"2": [],
				"3": [],
				"4": [],
				"5": [],
			},
			c: [],
			overlay: null,
			content: null,
			groups: null,
		}
	},
	async created()
	{
		
	},
	async mounted()
	{
		this.loading = true
		await this.getData()
		await this.getStatisticData()
		this.mapRender()
		this.loading = false
	},
	methods:
	{
		async updateMap()
		{
			await this.getData()
			if(this.clusters)
			{
				this.clusters.getSource().setSource(new VectorSource({ features: this.points})) 
			}
			if(this.type == "流量計")
			{
				this.map.addLayer(this.groups)
			}
			else
			{
				this.map.removeLayer(this.groups)
			}
		},
		closeCard(unit)
		{
			if(unit === '1')
			{
				this.statistic_1_overlay.setPosition(undefined)
			}
			else if(unit === '2')
			{
				this.statistic_2_overlay.setPosition(undefined)
			}
			else if(unit === '3')
			{
				this.statistic_3_overlay.setPosition(undefined)
			}
			else if(unit === '4')
			{
				this.statistic_4_overlay.setPosition(undefined)
			}
			else if(unit === '5')
			{
				this.statistic_5_overlay.setPosition(undefined)
			}
		},
		mapRender()
		{
			this.map_loader = new Loader({
						// apiKey: "",
						version: "weekly",
						libraries: ["places"]
					})

			this.map_loader.load().then( async (google) =>
			{
				this.map = new google.maps.Map( this.$refs['map-root'], 
					{ 
						center:
						{
							lat: 25.02,
							lng: 121.54,
						},
						zoom: 12 
					})

				this.infoWindow = new google.maps.InfoWindow({
					content: "",
					disableAutoPan: true,
				})

				//群組用戶
				_.forEach( this.points_g, e => 
				{
					let marker = new google.maps.Marker({
						position: { lat: e.lat, lng: e.lng },
						map: this.map,
						label: {
							color: 'black',
							fontWeight: 'bold',
							fontSize: '14px',
							text: e.label,
							className: 'marker-position',
						},
						icon: "https://amr.water.gov.taipei:8080/twdim/img/home_3.png",
					})

					marker.addListener( "click", () =>
					{
						this.groupRouterPush(e.id, e.name)
					})
				})

				this.markers = this.points.map( p => 
				{
					let marker = new google.maps.Marker({
						title: p.label,
						label: {
							color: 'black',
							fontWeight: 'bold',
							fontSize: '14px',
							text: p.label,
							className: 'marker-position',
						},
						position: { lat: p.lat, lng: p.lng },
					})

					marker.addListener( "click", () =>
					{
						this.routerPush(p.waterId, p.waterNum, p.meterNum)
					})

					return marker
				})

				this.markerCluster = new MarkerClusterer({ 
					map: this.map,
					markers: this.markers,
					onClusterClick: this.onClusterClickHandler
				})
			})
			.catch( e =>
			{
				console.log('err', e)
			})
			.finally( () =>
			{
				
			})

		},
		onClusterClickHandler(e, cluster, map)
		{
			// if(map.zoom < 16)
			// {
			// 	map.fitBounds(cluster.bounds)
			// }
			// else
			// {
			// 	this.infoWindow.open({ anchor: cluster, map, })
			// }

			map.fitBounds(cluster.bounds)
		},
		async getStatisticData()
		{
			this.tableData = 
			{
				"1": [],
				"2": [],
				"3": [],
				"4": [],
				"5": [], 
			}
			let arr = ["1", "2", "3", "4", "5"]
			let r = {
					index: "社區 用水情形",
					leakage: 0,
					lost: 0,
					normal: 0,
				}
			let url = "/api/report/waterStatistics/community"
			await this.axios.get(url).then( res =>
			{	
				res = res.data
				_.forEach(arr, e => 
				{
					if(_.has(res, e))
					{
						this.tableData[e].push(
							{
								index: "社區 用水情形",
								lost: res[e]["lost"],
								normal: res[e]["normal"],
							}
						)
					}
					else
					{
						this.tableData[e].push(r)
					}
				})
			})
			
			url = "/api/report/waterStatistics/general"
			r = {
					index: "一般 用水情形",
					leakage: 0,
					lost: 0,
					normal: 0,
				}
			await this.axios.get(url).then( res =>
			{
				res = res.data
				_.forEach(arr, e => 
				{
					if(_.has(res, e))
					{
						this.tableData[e].push(
							{
								index: "一般 用水情形",
								lost: res[e]["lost"],
								normal: res[e]["normal"],
							}
						)
					}
					else
					{
						this.tableData[e].push(r)
					}
				})
			})
		},

		async getData()
		{
			let url = ""
			if(this.type === "壓力計")
			{
				this.loading = true
				url = "/api/system/monitor?size=9999"
				await this.axios.get(url).then( res =>
				{
					if(_.isArray(res.data.content))
					{
						this.points = []
						_.forEach( res.data, (e) =>
						{
							// this.points[index] = new Feature(new Point( [e.lng, e.lat]))
							// this.points[index].set("label", e.waterNum + " - [" + e.waterName + "] - " + e.meterNum)
							// this.points[index].set("waterId", e.waterId)
							// this.points[index].set("waterNum", e.waterNum)
							// this.points[index].set("meterNum", e.meterNum)
							// this.labels.push( {value: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum })

							this.points.push(
								{
									lng: e.lng,
									lat: e.lat,
									label: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum,
									waterId: e.waterId,
									waterNum: e.waterNum,
									meterNum: e.meterNum,
								}
							)
						})
					}
					else
					{
						this.$message({ message: '無法擷取資料!', type: 'warning' }) 
					}
				})
				.catch( err =>
				{
					this.$message({ message: '無法擷取資料!', type: 'warning' })
					console.log(err)
				})
				.finally( () =>
				{
					this.loading = false
				})
			}
			else if(this.type === "流量計")
			{
				url = "https://webpms-watertaipei.cdn.hinet.net/gps1.json?token=MjrBoKdc8EdBXmWy_KR8Vw"
				await this.axios.get(url).then( res =>
				{
					if(_.isArray(res.data))
					{
						this.points = []
						this.labels = []
						_.forEach( res.data, (e) =>
						{
							// this.points[index] = new Feature(new Point( [e.lng, e.lat]))
							// this.points[index].set("label", e.waterNum + " - [" + e.waterName + "] - " + e.meterNum)
							// this.points[index].set("waterId", e.waterId)
							// this.points[index].set("waterNum", e.waterNum)
							// this.points[index].set("meterNum", e.meterNum)
							// this.labels.push( {value: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum })

							this.points.push(
								{
									lng: e.lng,
									lat: e.lat,
									label: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum,
									waterId: e.waterId,
									waterNum: e.waterNum,
									meterNum: e.meterNum,
								}
							)

						})

					}
					else
					{
						this.$message({ message: '無法擷取資料!', type: 'warning' }) 
					}
				})
				.catch( () =>
				{
					this.$message({ message: '無法擷取資料!', type: 'warning' })
				})
				.finally( () =>
				{
					this.loading = false
				})

				// 群組用戶
				url = "/api/system/profileGroup/gps"
				await this.axios.get(url).then( res =>
				{
					if(_.isArray(res.data))
					{
						this.points_g = []
						this.labels_g = []
						_.forEach( res.data, (e) =>
						{
							this.points_g.push(
								{
									id:e.id,
									name:e.name,
									lng: e.lng,
									lat: e.lat,
									label: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum,
									waterId: e.waterId,
									waterNum: e.waterNum,
									meterNum: e.meterNum,
								}
							)
							// this.points.push(
							// 	{
							// 		lng: e.lng,
							// 		lat: e.lat,
							// 		label: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum,
							// 		waterId: e.waterId,
							// 		waterNum: e.waterNum,
							// 		meterNum: e.meterNum,
							// 	}
							// )
						})
					}
					else
					{
						throw false
					}
				})
				.catch( () =>
				{
					this.$message({ message: '無法擷取資料!', type: 'warning' })
				})
				.finally( () =>
				{
					this.loading = false
				})

			}
		},

		routerPush(waterId, waterNum, meterNum)
		{
			let currentProfile = {
						waterId: waterId,
						waterNum: waterNum,
						meterNum: meterNum
					}
			localStorage.setItem('currentProfile', JSON.stringify(currentProfile))
			this.$router.push('/profile')
		},

		groupRouterPush(groupId, groupName)
		{
			let currentCommunitGroup = {
				groupId: groupId,
				groupName: groupName
			}

			localStorage.setItem('currentCommunitGroup', JSON.stringify(currentCommunitGroup))

			this.$router.push('/CommunityGroupList')
		},

		async querySearch(queryString, cb)
		{
			let r = []
			await this.axios.get("/api/system/profile/gps?keywords=" + queryString).then( res =>
			{
				if(_.isArray(res.data))
				{
					_.forEach( res.data, (e) =>
					{
						r.push( { value: e.waterNum + " - [" + e.waterName + "] - " + e.meterNum })
					})
				}
				else
				{
					throw false
				}
			})
			.catch( () =>
			{
				this.$message({ message: '無法擷取資料!', type: 'warning' })
			})
			.finally( () =>
			{
				cb(r)
			})
		},

		handleSelect(item)
		{
			this.target = item.value
			let features = this.points[ _.findIndex(this.labels, item) ]			
			let extent = boundingExtent( [features.getGeometry().getCoordinates()])
			this.map.getView().fit(extent, {duration: 1000, padding: [50, 50, 50, 50]})
		}
	}
}
</script>

<style scoped>
.box {
	border:1px solid #cccccc;
	width: 350px;
	height: 400px;
	background-color:#FFFFFF;
	padding:5px;
	overflow:auto;
}

.card {
    width: 420px;
	height: 200px;
  }
.marker-position {
    bottom: 6px;
    left: 0;
    position: relative;
}
</style>